import { LABELS } from './flatfileLabels'
import { escapeRegExp } from 'lodash'
import getColumnWidth from '../utils/getFlatfileColumnWidth'
import { SEARCH_ORDER_PROHIBITED_COMPANIES } from 'config/search-services'

export const searchOrderProhibitedCompaniesRegex =
  SEARCH_ORDER_PROHIBITED_COMPANIES.map(
    (company) => `(^${escapeRegExp(company)}$)`
  ).join('|')

export const getSearchFields = () => [
  {
    label: LABELS.PLAN_FIDUCIARY_NAME,
    key: 'planSponsorName',
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'planSponsorName' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.PLAN_FIDUCIARY_NAME),
    },
  },
  {
    label: LABELS.COMPLETE_LEGAL_PLAN_NAME,
    key: 'planName',
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'planName' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.COMPLETE_LEGAL_PLAN_NAME),
    },
  },
  {
    label: LABELS.PLAN_EMPLOYER_IDENTIFICATION_NUMBER,
    key: 'planEin',
    type: 'string',
    constraints: [{ type: 'external', validator: 'planEin' }],
    appearance: {
      size: getColumnWidth(LABELS.PLAN_EMPLOYER_IDENTIFICATION_NUMBER),
    },
  },
  {
    label: LABELS.THREE_DIGIT_PLAN_NUMBER,
    key: 'planNumber',
    type: 'string',
    constraints: [{ type: 'external', validator: 'planNumber' }],
    appearance: {
      size: getColumnWidth(LABELS.THREE_DIGIT_PLAN_NUMBER),
    },
  },
  {
    label: LABELS.PARTICIPANT_SSN,
    key: 'ssn',
    type: 'string',
    constraints: [{ type: 'external', validator: 'ssn' }],
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_SSN),
    },
  },
  {
    label: LABELS.PARTICIPANT_FIRST_NAME,
    key: 'firstName',
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'firstName' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_FIRST_NAME),
    },
  },
  {
    label: LABELS.PARTICIPANT_MIDDLE_NAME,
    key: 'middleName',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_MIDDLE_NAME),
    },
    constraints: [{ type: 'external', validator: 'middleName' }],
  },
  {
    label: LABELS.PARTICIPANT_LAST_NAME,
    key: 'lastName',
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'lastName' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_LAST_NAME),
    },
  },
  {
    label: LABELS.PARTICIPANT_ADDRESS_1,
    key: 'address1',
    type: 'string',
    constraints: [{ type: 'external', validator: 'address1' }],
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_ADDRESS_1),
    },
  },
  {
    label: LABELS.PARTICIPANT_ADDRESS_2,
    key: 'address2',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_ADDRESS_2),
    },
  },
  {
    label: LABELS.PARTICIPANT_ADDRESS_3,
    key: 'address3',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_ADDRESS_3),
    },
  },
  {
    label: LABELS.PARTICIPANT_CITY,
    key: 'city',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_CITY),
    },
  },
  {
    label: LABELS.PARTICIPANT_STATE,
    key: 'state',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_STATE),
    },
  },
  {
    label: LABELS.PARTICIPANT_ZIP,
    key: 'zipCode',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_ZIP),
    },
  },
  {
    label: LABELS.PARTICIPANT_DOB,
    key: 'dob',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_DOB),
    },
  },
  {
    label: LABELS.PARTICIPANT_DOD,
    key: 'dod',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.PARTICIPANT_DOD),
    },
  },
  {
    label: LABELS.PHONE_NUMBER,
    key: 'phone',
    type: 'string',
    constraints: [{ type: 'external', validator: 'phone' }],
    appearance: {
      size: getColumnWidth(LABELS.PHONE_NUMBER),
    },
  },
  {
    label: LABELS.WORK_FOR,
    key: 'workFor',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.WORK_FOR),
    },
  },
  {
    label: LABELS.REASON,
    key: 'reason',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.REASON),
    },
  },
  {
    label: LABELS.MISCELLANEOUS_1,
    key: 'miscellaneous1',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.MISCELLANEOUS_1),
    },
  },
  {
    label: LABELS.MISCELLANEOUS_2,
    key: 'miscellaneous2',
    type: 'string',
    appearance: {
      size: getColumnWidth(LABELS.MISCELLANEOUS_2),
    },
  },
]
